if(
   document.getElementsByClassName("comic-nav").length > 0 &&
   typeof comicData != "undefined"
){
   const comicContainer = document.getElementById("cc-comic1-container");

   document.addEventListener("DOMContentLoaded", function(){
      if(comicContainer){
         comic1Stuff();
      }else{
         comic2Stuff();
      }
   });

   // ----------------------------------------------------------------------------------------------
   function comic1Stuff(){
      const chapterSelect = document.getElementById("chapter-select");
      const pageSelect = document.getElementById("page-select");
      const prevPage = document.getElementById("comic1-prev");
      const nextPage = document.getElementById("comic1-next");
      const comicImages = comicContainer.getElementsByTagName("img");
      let currentChapterSlug = comicData.hierarchy[comicData.hierarchy.length - 1];
      let currentChapter = null; // object
      let currentPageIndex = 0;
      let pageSelectOptions = [];
      
      // Get current chapter
      for(let i = 0; i < comicData.seasonlessChapters.length; ++i){
         let chapter = comicData.seasonlessChapters[i];
         if(chapter["slug"] == currentChapterSlug){
            currentChapter = chapter;
         }
      }

      // Nav

      for(let n = 0; n < comicData.seasonlessChapters.length; ++n){
         let newOption = document.createElement("option");
         let chapter = comicData.seasonlessChapters[n];
         newOption._slug = chapter.slug;
         newOption.text = chapter.label;
         chapterSelect.add(newOption);

         if(chapter == currentChapter){
            newOption.selected = true;
         }
      }

      for(let n = 0; n < comicImages.length; ++n){
         let newOption = document.createElement("option");
         newOption._index = n;
         newOption.text = (n + 1).toString();
         pageSelect.add(newOption);
         pageSelectOptions.push(newOption);
      }

      chapterSelect.addEventListener("change", function(){
         let chapterSlug = chapterSelect.options[chapterSelect.selectedIndex]._slug;
         let url = comicData.baseURL;
         for(let i = 0; i < comicData.hierarchy.length - 1; ++i){
            url += comicData.hierarchy[i] + "/";
         }
         url += chapterSlug + "/";
         window.location.href = url;
      });

      pageSelect.addEventListener("change", function(){
         let index = pageSelect.options[pageSelect.selectedIndex]._index;
         setPage(index);
      });

      // Page turning

      for(let n = 0; n < comicImages.length; ++n){
         comicImages[n].addEventListener("click", goNextPage);
      }
      prevPage.addEventListener("click", goPrevPage);
      nextPage.addEventListener("click", goNextPage);

      function goPrevPage(){
         let newIndex = currentPageIndex - 1;
         if(newIndex < 0){
            // go to previous chapter, maybe?
         }else{
            setPage(newIndex);
         }
      }

      function goNextPage(){
         let newIndex = currentPageIndex + 1;
         if(newIndex > comicImages.length - 1){
            // go to next chapter, maybe?
         }else{
            setPage(newIndex);
         }
      }

      // Don't let the browser load every image, just the current one (and cache the next one)
      function setPage(index){
         // lock container size
         comicContainer.style.minWidth = comicContainer.clientWidth + "px";
         comicContainer.style.minHeight = comicContainer.clientHeight + "px";

         comicImages[currentPageIndex].style.display = "none";

         let prevIndex = currentPageIndex;
         currentPageIndex = index;

         // Make the background the previous image, to prevent flickering
         comicImages[currentPageIndex].style.backgroundImage = (
            "url(" + comicImages[prevIndex].src + ")"
         );
         comicImages[currentPageIndex].style.backgroundSize = "100% 100%";

         // unlock container size on image load, also scroll to top
         let c = comicImages[currentPageIndex];
         comicImages[currentPageIndex].onload = function(){
            comicContainer.style.minWidth = "unset";
            comicContainer.style.minHeight = "unset";
            c.onload = null;

            document.getElementById("top").scrollIntoView();
         }

         comicImages[currentPageIndex].src = comicImages[currentPageIndex].dataset.src;
         comicImages[currentPageIndex].style.display = "block";

         // Make next page load quicker
         let nextIndex = index + 1;
         if(nextIndex < comicImages.length){
            comicImages[nextIndex].src = comicImages[nextIndex].dataset.src;
         }

         pageSelectOptions[index].selected = true;

         window.history.replaceState(null, "", window.location.pathname + "?pg=" + (index + 1));
      }

      // Get current page from url
      if(window.location.search.length > 0){
         let pageNumber = parseInt(window.location.search.substring("?pg=".length));
         if(!isNaN(pageNumber)){
            comicImages[0].style.display = "none";
            currentPageIndex = pageNumber - 1;
            if(currentPageIndex < 0) currentPageIndex = 0;
            if(currentPageIndex > comicImages.length - 1) currentPageIndex = comicImages.length - 1;
         }
      }
      setPage(currentPageIndex);
   }

   // ----------------------------------------------------------------------------------------------
   function comic2Stuff(){
      const seasonSelect = document.getElementById("season-select");
      const episodeSelect = document.getElementById("episode-select");
      let currentSeasonSlug = comicData.hierarchy[comicData.hierarchy.length - 2];
      let currentEpisodeSlug = comicData.hierarchy[comicData.hierarchy.length - 1];
      let currentSeason = null;
      let currentEpisode = null;

      // Get current season and chapter
      for(let s = 0; s < comicData.seasons.length; ++s){
         let season = comicData.seasons[s];
         if(season.slug == currentSeasonSlug){
            currentSeason = season;

            for(let c = 0; c < season.chapters.length; ++c){
               let chapter = season.chapters[c];
               if(chapter.slug == currentEpisodeSlug){
                  currentEpisode = chapter;
               }
            }

            break;
         }
      }

      // Nav

      for(let s = 0; s < comicData.seasons.length; ++s){
         let newOption = document.createElement("option");
         let season = comicData.seasons[s];
         newOption._slug = season.slug;
         newOption.text = season.label;
         seasonSelect.add(newOption);

         if(season.slug == currentSeason.slug){
            newOption.selected = true;

            for(let c = 0; c < season.chapters.length; ++c){
               let newOption = document.createElement("option");
               let episode = season.chapters[c];
               newOption._slug = episode.slug;
               newOption.text = episode.label;
               episodeSelect.add(newOption);

               if(episode.slug == currentEpisode.slug){
                  newOption.selected = true;
               }
            }
         }
      }

      seasonSelect.addEventListener("change", function(){
         let seasonSlug = seasonSelect.options[seasonSelect.selectedIndex]._slug;
         for(let n = 0; n < comicData.seasons.length; ++n){
            if(comicData.seasons[n].slug == seasonSlug){
               let firstEpisodeSlug = comicData.seasons[n].chapters[0].slug;
               let url = comicData.baseURL;
               for(let i = 0; i < comicData.hierarchy.length - 2; ++i){
                  url += comicData.hierarchy[i] + "/";
               }
               url += seasonSlug + "/";
               url += firstEpisodeSlug + "/";
               window.location.href = url;

               break;
            }
         }
      });

      episodeSelect.addEventListener("change", function(){
         let seasonSlug = seasonSelect.options[seasonSelect.selectedIndex]._slug;
         let episodeSlug = episodeSelect.options[episodeSelect.selectedIndex]._slug
         let url = comicData.baseURL;
         for(let i = 0; i < comicData.hierarchy.length - 2; ++i){
            url += comicData.hierarchy[i] + "/";
         }
         url += seasonSlug + "/";
         url += episodeSlug + "/";
         window.location.href = url;
      });
   }
}
